// extracted by mini-css-extract-plugin
export var parsedInfoBoxList = "bc_dp";